import { render, staticRenderFns } from "./TeamJoinForm.vue?vue&type=template&id=4d97c48c&"
import script from "./TeamJoinForm.vue?vue&type=script&lang=ts&"
export * from "./TeamJoinForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports